import { array } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { replaceTextLinksWithHtml } from 'webapp/utils/html';

import joinClasses from 'webapp/helpers/join-classes';
import CustomQuerySetupPrebuiltFieldComponent from 'webapp/components/custom-query/setup/prebuilt/field';
import type {
	CustomMetricSetupForm,
	CustomMetricSetupFormItemGroup,
} from 'webapp/components/custom-query/setup/prebuilt/group';
import CustomQuerySetupPrebuiltGroupComponent from 'webapp/components/custom-query/setup/prebuilt/group';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

import type CustomMetricSetupFormItemField from 'webapp/models-custom/custom-metric-setup-form/item/field';

interface Args {
	form: CustomMetricSetupForm;
	model: CustomMetricSetupFormItemField | CustomMetricSetupFormItemGroup;
	isDisabled: boolean;
	onContentChange: () => void;
	groupItems?: (CustomMetricSetupFormItemField | CustomMetricSetupFormItemGroup)[];
}

export default class CustomQuerySetupPrebuiltFormItemComponent extends Component<Args> {
	@service('account') declare accountService: Service.Account;

	get modelAsItem() {
		return this.args.model as CustomMetricSetupFormItemField;
	}

	get modelAsGroup() {
		return this.args.model as CustomMetricSetupFormItemGroup;
	}

	get groupItemsAsFields(): CustomMetricSetupFormItemField[] {
		return this.args.groupItems as CustomMetricSetupFormItemField[];
	}

	get typeClass(): string {
		let typeClass = 'item';
		const model = this.args.model;
		if ((model as CustomMetricSetupFormItemGroup).isTitle) {
			typeClass += '-title';
		} else if ((model as CustomMetricSetupFormItemGroup).isGroup) {
			typeClass += '-group';
		}
		return typeClass;
	}

	get formattedTitle(): string {
		return replaceTextLinksWithHtml(this.args.model.name);
	}

	get showLearnMore(): boolean {
		return (
			!!(this.args.model as CustomMetricSetupFormItemGroup).nameLink &&
			!this.accountService.hideDataboxNotWhiteLabeledContentForNonAdmins
		);
	}
	<template>
		<div
			class={{joinClasses
				(array
					this.modelAsItem.sizeClass
					this.typeClass
					(if this.modelAsItem.sameRow "connected")
					(if @model.isHiddenOnUI "hidden")
				)
			}}
		>
			{{#if this.modelAsGroup.isTitle}}

				<label class="title">{{{this.formattedTitle}}}</label>
				{{#if @model.description}}
					<ToolTipWithIconComponent @text={{@model.description}} />
				{{/if}}
				{{#if this.showLearnMore}}
					<a href={{this.modelAsGroup.nameLink}} target="_blank">Learn more</a>
				{{/if}}

			{{else if this.modelAsGroup.isGroup}}

				<CustomQuerySetupPrebuiltGroupComponent
					@model={{this.modelAsGroup}}
					@form={{@form}}
					@onContentChange={{@onContentChange}}
					@isDisabled={{@isDisabled}}
				/>

			{{else}}

				<CustomQuerySetupPrebuiltFieldComponent
					@model={{this.modelAsItem}}
					@form={{@form}}
					@groupItems={{this.groupItemsAsFields}}
					@onContentChange={{@onContentChange}}
					@isDisabled={{@isDisabled}}
				/>

			{{/if}}
		</div>
	</template>
}
